// JavaScript Document
//components/signs/stats/Histogram.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
//import { Chart } from 'react-charts';
import AChart from 'react-apexcharts';

const useStyles = makeStyles({
  croot: {
	  flexGrow:1,
	  width: '100%',
	  height: '100%',
	  minHeight: 300
   // minWidth: 650,
	//maxHeight:'calc(100vh - 84px)',
	//maxHeight: '100%'
  },
});


export default function Histogram(props) {
	const classes = useStyles();
	const {items, summary} = props;
	const series = React.useMemo(
		() => ({
		type: 'area'
		}),
		[]
	);
	const axes = React.useMemo(
		() => [
		{
			primary: true,
			position: 'bottom',
			type: 'linear',
			//label: 'Speed'
			//label: 'Speed'
		}, {
			position: 'left',
			type: 'linear',
			stacked: true,
			//label:'Count'
		}], []
	);
	
	const data = () => {
		return [{
			label: 'Count',
			data: items.map(dat => {
				return {
					primary: dat.peak,
					secondary: dat.total
				}}
			)
		}];
	}

	const aopts = {
		chart : {
			id: 'speed-histogram'
		},
		//xaxis: {
		//	categories: items.map(dat => dat.peak)
		//},
		xaxis: {
			type: 'numeric',
			decimalsInFloat: 0,
		},
		stroke: {
			curve: 'smooth'
		},
		dataLabels: {
			enabled: false
		},
		tooltip: {
			x: {
				formatter: (v => parseInt(v).toString()+'mph')
			}
		},
		annotations: {
			xaxis: [{
				x: summary.percentile_speed,
				borderColor: '#A00',
				label: {
					borderColor: '#A00',
					style: {
						color: '#fff',
						background: '#A00'
					},
					text: summary.percentile+'th percentile'
				}
			}, {
				x: summary.speed_limit,
				borderColor: '#0A0',
				label: {
					borderColor: '#0A0',
					style: {
						color: '#FFF',
						background: '#0A0'
					},
					text: 'speed limit'
				}
			}]
		}
	}
	const aseries = [{
		name: 'Count',
		//data: items.map(d => d.total)
		data: items.map(d => [d.peak, d.total]),
	}]
	console.log(series);
	console.log(axes);
	console.log(data());
	
	
	//<Chart data={data()} series={series} axes={axes} tooltip />

  return (
	  <Box className={classes.croot}>
	  
	  <AChart options={aopts} series={aseries} type="area" height='100%' />
	  </Box>
  );
}
